import {OptionTypeBase, OptionProps, Styles} from "react-select"

import mainTheme from "@irati/ui/src/global/theme"
import {boldStyles, regularStyles} from "@irati/ui/src/Typography/Input/styles"

const getBgColor = (state: OptionProps<OptionTypeBase>) => {
  if (state.isSelected) return mainTheme.colors.primary2
  else if (state.isFocused) return mainTheme.colors.utility.highlight

  return mainTheme.colors.utility.white
}

const selectStyles: Styles = {
  container: (base) => ({
    ...base,
    margin: `${mainTheme.spacing.one} 0`
  }),
  control: (base, state) => ({
    ...base,
    border: `1px solid ${state.isFocused ? mainTheme.colors.primary1 : mainTheme.colors.greys.grey20}`,
    borderRadius: mainTheme.border.radius.small,
    boxShadow: state.isFocused ? mainTheme.shadows.focus : "none",
    minHeight: 48
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: mainTheme.colors.greys.grey50,
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "none",
    "&:hover": {
      color: mainTheme.colors.greys.grey50
    }
  }),
  menu: (base) => ({
    ...base,
    margin: `${mainTheme.spacing.one} 0`,
    boxShadow: mainTheme.shadows.low
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    borderRadius: mainTheme.border.radius
  }),
  multiValue: (base) => ({
    ...base,
    borderRadius: 18,
    backgroundColor: mainTheme.colors.utility.highlight,
    padding: 0,
    fontFamily: mainTheme.font.bold,
    ...(boldStyles as any)
  }),
  multiValueLabel: (base) => ({
    ...base,
    paddingLeft: 3
  }),
  multiValueRemove: (base) => ({
    ...base,
    ":hover": {
      backgroundColor: "transparent",
      cursor: "pointer"
    }
  }),
  option: (base, state) => ({
    ...base,
    padding: mainTheme.spacing.two,
    backgroundColor: getBgColor(state),
    ":active": {
      backgroundColor: getBgColor(state)
    },
    ...(regularStyles as any)
  }),
  valueContainer: (base) => ({
    ...base,
    padding: `0 ${mainTheme.spacing.two}`
  })
}

export default selectStyles
